import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getContractsRequest } from '../api/contractApi';
import { getContractsAction } from '../redux/actions/contractAction';

export const useContractApi = () => {
  const dispatch = useDispatch()

  const getContracts = useCallback(async (id: Number | null) => {
    await getContractsRequest(id)
      .then(response => {
        dispatch(getContractsAction(response.data))
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  return {
    getContracts,
  }
}
